<template>
  <div>
    <div class="container">
        <v-form ref="form" lazy-validation>
          <form-config
            ref="config"
            :formulario="formulario"
            tabela="apontamentoproducao"
          />
            <div class="d-flex justify-center contaainer">
              <v-text-field ref="balanca"
              outlined label="Numero Balança" class="textfield n-center"
              background-color="white" type="number"
              :rules="rules.appnumerobalanca"
              v-model="formulario.appnumerobalanca"
              @keydown="$_limitaBalanca"
              @keyup.enter="$refs.balanca.blur(); $refs.lote.$children[0].focus();"></v-text-field>
                <card-auto-complete ref="lote"
                  label="Código DUN"
                  class="textfield n-center"
                  :dados="lotesdaop"
                  :readonly="!lotesdaop"
                  v-model="formulario.appidaberturalote"
                  itemLabel="ablnrocontrole"
                  item-value="ablidaberturalote"
                  :return-object="false"
                  :rules="rules.ablidaberturalote"
                  hide-details
                  icon="mdi-qrcode-scan"
                  :action="$_onClickQR"
                  @focus="$_scrollUp($event)"
                  @keyup.enter="$refs.lote.$children[0].blur(); $refs.peso.focus()"
                />
              <!-- <div class="linha-qr">
              </div> -->
              <!-- <v-text-field outlined label="Data/Hora" class="textfield n-center" readonly
              v-model="formulario.appdatapesagem"></v-text-field> -->
            <v-card class="descricaoextra" v-if="lotecompleto?.abldescricao">
              <b class="centerextra" style="font-weight: 600;">{{lotecompleto?.abldescricao}}</b>
              <v-divider></v-divider>
              <b class="centerextra" style="font-weight: 600;">{{lotecompleto?.ablgranulometria}}</b>
              <v-divider></v-divider>
              <b class="centerextra" style="font-weight: 600;">{{variedadeCompleta?.vardescricao}}</b>
              <v-divider v-if="apontamentoCompleto?.apppeso"></v-divider>
              <b class="centerextra" style="font-weight: 600;">{{apontamentoCompleto?.apppeso}}</b>
            </v-card>
            <v-text-field ref="peso"
            outlined label="Peso" class="textfield n-center" type="number"
            background-color="white" :rules="rules.apppeso"
            v-model="formulario.apppeso"
            @keyup.enter="$refs.peso.blur(); $refs.local.focus()"></v-text-field>
            <v-autocomplete ref="local"
            :items="locaisdaop"
            :readonly="!locaisdaop"
            item-text="loadescricao"
            item-value="loaidlocalarmazenamento"
            outlined label="Local"
            class="textfield n-center"
            background-color="white"
            :rules="rules.appidlocalmovimentacaoestoque"
            v-model="formulario.appidlocalmovimentacaoestoque"
            @keyup.enter="$refs.local.blur(); $refs.turno.focus()"></v-autocomplete>
            <v-autocomplete ref="turno"
            :items="turnosdaop"
            :readonly="!turnosdaop"
            item-text="tupidturno"
            item-value="tupidturno"
            outlined label="Turno"
            class="textfield n-center"
            background-color="white"
            :rules="rules.appidturno"
            v-model="formulario.appidturno"
            @keyup.enter="$refs.turno.blur(); $refs.fabrica.focus()"></v-autocomplete>
            <v-autocomplete ref="fabrica"
            label="Fabrica"
            :items="fabricasdaop"
            :readonly="!fabricasdaop"
            item-text="fabdescricao"
            item-value="fabidfabrica"
            outlined
            class="textfield n-center"
            background-color="white"
            :rules="rules.appidfabrica"
            v-model="formulario.appidfabrica"
            @keyup.enter="$refs.fabrica.blur(); $_verificaDuplicado()"></v-autocomplete>
            <v-btn color="primary" class="salvar" @click="$_verificaDuplicado" width="125px">
              <div v-if="!enviando">Salvar</div>
              <v-progress-circular v-else
                indeterminate
                color="white"
              ></v-progress-circular>
            </v-btn>

            </div>
        </v-form>
      <br/>
    </div>
  </div>
</template>

<script>

import { ROUTE_PRODUCAO_CADASTRO, ROUTE_LOTES_FINALIZADOS, ROUTE_QR, ROUTE_PRODUCAO_DUN  } from '@/constants/ROUTES';

import FormConfig from '@/components/form/components/form-config/Index.vue';
import CardAutoComplete from '@/components/core/card-auto-complete/Index.vue'

import { OPLOCAL_STORAGE } from '@/constants/STORAGE'

import geraData from '@/utils/geradata'

import $_scrollUp from '@/utils/scroll-up'


import db from '@/plugins/dexie';

import moment from 'moment-timezone';

function getSessionStorage(key, defaultValue) {
  return sessionStorage.getItem(key) ?? defaultValue;
}


import errorHandler from '@/utils/error-handler';
import { SetupEnvioLocal } from '@/utils/atualizalocal';
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  name: 'ViewLoteDun',

  components: {
    FormConfig,
    CardAutoComplete,
  },

  data() {
    return {
      rotaFiltros: [
        ROUTE_PRODUCAO_CADASTRO,
      ],

      fabrica: null,
      loading: true,
      lotes: null,

      lotesdaop: null,
      locaisdaop: null,
      turnosdaop: null,
      fabricasdaop: null,

      lotesfechados: null,
      proximolote: null,
      proximoembalagem: null,
      idordemproducao: null,

      formulario: {
        appnumerobalanca: null,
        apppeso: null,
        appidaberturalote: null,
        appidlocalmovimentacaoestoque: null,
        appdatapesagem: null,
        appdataalteracao: null,
        appidturno: null,
        appdatanuvem: null,
        appidusuario: null,
        appidnuvem: null,
        appidfabrica: null,
      },
      lotecompleto: null,
      apontamentoCompleto: null,
      variedadeCompleta: null,

      rules: {
        appnumerobalanca: [ v => !!v || 'Numero Balança é obrigatório' ],
        apppeso: [ v => !!v || 'Peso é obrigatório' ],
        appidlocalmovimentacaoestoque: [ v => !!v || 'Local é obrigatório' ],
        ablidaberturalote: [ v => !!v  || 'Lote é obrigatório', !this.jaexiste || 'Já existe um lançamento com esse lote'],
        appobsduplicado: [ v => !!v || 'Observação é obrigatória'],
        appidturno: [ v => !!v || 'Turno é obrigatório'],
        appidfabrica: [ v => !!v || 'Fabrica é obrigatória'],
      },

      itensComEsseNro: null,

      lotesMaisRecentes: [],

      dialogloterepetido: false,

      enviando: false,

      idempresa: null,

      jaexiste: true,
    };
  },

  methods: {
    ...mapMutations({
      $_adicionarCache: 'cache/SET_CACHE',
    }),

    ...mapActions({
      $_getCache: 'cache/getCache',
      $_reloadCache: 'cache/reloadCache',
    }),

    async  $_scrollUp(e) {
        $_scrollUp(e);
    },
    async $_setup() {
      this.idempresa = sessionStorage.getItem('idempresa');
      if (this.idempresa !== 'a97bdbfc-8ede-4e1a-832f-54521a20c3d8') {
        this.formulario.appnumerobalanca = 1;
      }
      this.formulario.appdatapesagem = new Date();
      this.formulario.appdatapesagem.setHours(this.formulario.appdatapesagem.getHours() - 3);

      const ablcache = await this.$_getCache('aberturalotedun');
      const lmecache = await this.$_getCache('localarmazenamento');
      const turcache = await this.$_getCache('turno');
      const fabcache = await this.$_getCache('fabrica');

      if (!ablcache) {
        console.log('aberturalotedun cached');
        // DUN usa apenas os lotes que possuem código DUN, em um cache próprio
        // (separado do Lote C) para não misturar os conjuntos de dados.
        this.lotesdaop = await db.aberturalote
          .orderBy('ablnrocontrole')
          .filter((item) => !!item.ablcodigodun)
          .toArray();
        this.$_adicionarCache({tabela: 'aberturalotedun', dados: this.lotesdaop});
      } else {
        this.lotesdaop = this.$$_cacheLote;
      }

      if (!lmecache) {
        console.log('localarmazenamento cached');
        const lotesdb = await db.localarmazenamento.toArray();
        this.locaisdaop = lotesdb.filter((item) => item.loausadoapppesagem === 'S' );
        this.$_adicionarCache({tabela: 'localarmazenamento', dados: this.locaisdaop});
      } else {
        this.locaisdaop = this.$$_cacheLocal;
      }

       if (!turcache) {
        console.log('turno cached');
        this.turnosdaop = await db.turno.toArray();
        this.$_adicionarCache({tabela: 'turno', dados: this.turnosdaop});
       } else {
        this.turnosdaop = this.$$_cacheTurno;
       }

       if (!fabcache) {
        console.log('fabrica cached');
        this.fabricasdaop = await db.fabrica.toArray();
        this.$_adicionarCache({tabela: 'fabrica', dados: this.fabricasdaop });
       } else {
        this.fabricasdaop = this.$$_cacheFabrica;
       }


      this.turnosdaop.forEach((turno) => {
          const abertura = '2025' + turno.tupdataabertura.slice(4);
          const fechamento = '2025' + turno.tupdatafechamento.slice(4);

          const timeAbertura = moment.utc(abertura).add(3, 'hours');
          const timeFechamento = moment.utc(fechamento).add(3, 'hours');

          const nowTime = moment.utc();

          const format = 'HH:mm';
          const onlyTimeNow = nowTime.format(format);
          const onlyTimeAbertura = timeAbertura.format(format);
          const onlyTimeFechamento = timeFechamento.format(format);

          const tNow = moment.utc(onlyTimeNow, format);
          const tAbertura = moment.utc(onlyTimeAbertura, format);
          const tFechamento = moment.utc(onlyTimeFechamento, format);

          if (tNow.isSameOrAfter(tAbertura) && tNow.isSameOrBefore(tFechamento)) {
            this.formulario.appidturno = turno.tupidturno;
          }
      })
        this.$refs.peso.focus();
    },

    async $_limitaBalanca(e) {
      if (this.formulario.appnumerobalanca?.length > 2 && e.key !== 'Enter') {
        setTimeout(() => {
          this.formulario.appnumerobalanca= this.formulario.appnumerobalanca.slice(0, -1) //'abcde'
        })
      }
    },

    async $_submit() {
      if (this.enviando) {
        return;
      }
      if(await this.$_verificajaexiste()) {
        return;
      }
      if (this.$refs.form.validate()) {
        try {
          this.enviando = true;
          this.formulario.appdatapesagem = geraData(),
          this.formulario.appdataalteracao = geraData();
          this.formulario.appdatanuvem = null;
          this.formulario.appidnuvem = 'null';
          const res = await db.apontamentoproducao.add(this.formulario);
          if(res){
            errorHandler('Enviado com sucesso!');
            //
            SetupEnvioLocal();
            this.$_reloadCache('apontamentoproducao');
            //
            this.dialogloterepetido = false;
            sessionStorage.setItem(OPLOCAL_STORAGE.qr, '');
            this.formulario = {
              appnumerobalanca: null,
              apppeso: null,
              appidaberturalote: null,
              appidlocalmovimentacaoestoque: null,
              appdatapesagem: geraData(),
              appdataalteracao: geraData(),
              appidturno: this.formulario.appidturno,
              appdatanuvem: null,
              appidnuvem: null,
              appidfabrica: null,
            }
            if (this.idempresa !== 'a97bdbfc-8ede-4e1a-832f-54521a20c3d8') {
              this.formulario.appnumerobalanca = 1;
            }
            this.lotecompleto = null;
            this.$refs.form.resetValidation();
            this.enviando = false;
          }
        } catch(e) {
          this.enviando = false;
          console.log(e, 'eeeee');
          if(e.code == 'ERR_NETWORK'){
            errorHandler('Erro de conexão');
          } else {
            errorHandler(e);
          }
        }
      } else {
        errorHandler('Formulario inválido, verifique os dados e envie novamente');
      }
    },

    $_somaPeso(nro) {
      const itensComEsseNro = this.lotes.filter((item) => {
        return item.applote === nro;
      })

      const soma = itensComEsseNro.reduce((acc, cur) => {
        return acc +  Number(cur.appquantidade);
      }, 0);
      return soma;
    },

    $_verificaDuplicado() {
      this.$_submit();
    },

    async $_verificajaexiste() {
        const apontamentosrealizados = await db.apontamentoproducao.toArray();
        this.jaexiste = apontamentosrealizados.find((item) => {
          return (item.appidaberturalote === this.formulario.appidaberturalote)
        })
        if (this.jaexiste) {
          errorHandler('já existe um lançamento com este lote!');
        }
        return this.jaexiste;
    },

    FormataData(date, formato) {
      return moment.tz(date, 'America/Sao_Paulo').local().format(formato);
    },

    proximoInput() {
      this.$refs.loteb.$children[0].focus();
    },

    $_openDetalhe(nro) {
      sessionStorage.setItem(OPLOCAL_STORAGE.nro, nro);
      this.$router.replace({
        ...this.$route,
        name: ROUTE_LOTES_FINALIZADOS.name,
      });
    },

    $_onClickQR() {
      sessionStorage.setItem('formulario', JSON.stringify(this.formulario));
      sessionStorage.setItem('rota-anterior', ROUTE_PRODUCAO_DUN.path);
      // Sinaliza para a câmera que o QR veio da Ordem Produção DUN,
      // para aplicar a leitura/decode específica do DUN.
      sessionStorage.setItem('qrdun', 'true');
      setTimeout(() => {
        this.$router.push({
          ...this.$route,
          name: ROUTE_QR.name,
        });
      });
    },

    async $_verificaQR() {
      // Já voltamos da câmera: consome o flag do DUN aqui (e não no beforeDestroy,
      // que rodaria também na ida para a câmera e apagaria o flag cedo demais).
      sessionStorage.removeItem('qrdun');
      const qr = await getSessionStorage(OPLOCAL_STORAGE.qr, '');
      if (qr && qr.length && qr !== 'null') {
        // O QR do DUN traz o código DUN (ex.: 17898962664725), gravado direto
        // na aberturalote (ablcodigodun) pela API.
        const lote = await db.aberturalote.where({ ablcodigodun: qr }).toArray();
        console.log(qr, lote)
        if (!lote.length) {
          errorHandler('Lote (DUN) não encontrado');
          return;
        }
        this.lotecompleto = null;
        this.lotecompleto = lote[0];
        this.formulario.appidaberturalote = lote[0].ablidaberturalote;
        this.$refs.peso.focus();
      }
    },
  },

  created() {
    SetupEnvioLocal();
    const formulario = sessionStorage.getItem('formulario', null);
      if (formulario) {
        this.formulario = JSON.parse(formulario);
        this.$_verificaQR().then(() => {
          sessionStorage.removeItem('formulario');
        });
      }

    setTimeout(() => {
      this.$_setup();
    }, 0);
  },

  beforeDestroy() {
    sessionStorage.removeItem('qr');
  },

  computed: {
    ...mapState({
      $$_cacheLote: (state) => state.cache.cache_aberturalotedun,
      $$_cacheLocal: (state) => state.cache.cache_localarmazenamento,
      $$_cacheTurno: (state) => state.cache.cache_turno,
      $$_cacheFabrica: (state) => state.cache.cache_fabrica,
    }),

    $$appidaberturalote() {
      return this.formulario.appidaberturalote;
    }
  },

  watch: {
    $$appidaberturalote: {
      handler() {
        setTimeout(() => {
          if (this.formulario.appidaberturalote) {
            this.lotecompleto = null;
            const loteCompleto = (db.aberturalote.where({ ablidaberturalote: this.formulario.appidaberturalote }).toArray());
            loteCompleto.then((item) => {
              this.lotecompleto = item[0];
              db.produto.where({ proidproduto: item[0].ablidproduto }).toArray().then((itemProduto) => {
                if (itemProduto[0]?.proidvariedade) {
                  db.variedade.where({ varidvariedade: itemProduto[0]?.proidvariedade }).toArray().then((itemVariedade) => {
                    this.variedadeCompleta = itemVariedade[0];
                  })
                }
              })
            })
          }
        })
      }
    },

    proximolote() {
      sessionStorage.setItem('lote', JSON.stringify(this.proximolote));
    },

    proximoembalagem() {
      sessionStorage.setItem('loteembalagem', JSON.stringify(this.proximoembalagem));
    }
  }
};
</script>

<style scoped>
  .v-sheet--offset {
    top: 5px;
    position: relative;
  }


  .center {
    width: 100%;
    text-align: center;
  }

  .card {
    padding: 3px;
    margin: 15px 10px 0px 10px
  }

  .card-secador {
    width: 90%;
    text-align: center;
    margin: 20px;
  }

  .linhas {
    height: 21%;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
  }

  .finalizado {
    background-color: #4CAF50;
  }

  .iniciado {
    background-color: #6b93ff;
  }

  .disponivel {
    background-color: #b9b9b9;
  }

  .digitavel {
    margin-bottom: 25px;
  }

  .linha-menor {
    height: 16%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 4px 0px 4px;
    font-size: 13px;
  }

  .inner-card {
    display: flex;
    justify-content: space-between;
    height: 67%;
  }

  .container-inner-items {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .container-inner-items-fill {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .card-btn {
    transform: translateY(10px);
  }

  .txt-center {
    text-align: center;
  }

  .input-container {
      width: 60%;
  }

  .container {
    width: 93vw;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .contaainer {
    width: 93vw;
    max-width: 250px;
    flex-wrap: wrap;
  }

  .textfield {
    width: 90%;
  }

  .n-center >>> input {
      text-align: center;
  }

  .n-center >>> input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .nn-center >>> input {
      text-align: center;
  }

  .nn-center >>> input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .linha-qr {
    display: flex;
  }

  .numero-armazenamento {
    width: 33%;
  }

  .descricaoextra {
    color: #3d68de;
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    padding: 5px;
    background-color: #fdffd2;
  }

  .centerextra {
      flex: 1;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
  }



</style>
